import { View, StyleSheet, Text, Image, Link } from "@react-pdf/renderer";
import CaltexLubewatchLogo from "../../assets/images/logos/caltex-lubewatch-now.png"

const styles = StyleSheet.create({
    footer: {
        width: "100%",
        position: "absolute",
        bottom: 15
    },
    footerWeb: {
        flexDirection: "row",
        paddingLeft: 30,
        paddingRight: 30,
        paddingTop: 30,
        gap: 10
    },
    caltexLubewatch: { 
        marginTop: -5,
        marginLeft: -8
    }
});

const FooterPDF = () => {
    return (
        <View style={styles.footer}>
            <View style={styles.footerWeb}>
                <View style={{ width: "100px" }}>
                    <Image src={CaltexLubewatchLogo} style={styles.caltexLubewatch}/>
                </View>
                <View style={{ width: "100%" }}>
                    <Text style={{ fontSize: "5px", color: "#333" }}>
                        <Text style={{ fontWeight: "500", fontStyle: "italic" }}>Disclaimer Statement</Text> - The
                        results and information provided are based on a screening laboratory testing and reflect
                        observations to assist users make better decisions to maximize their assets. Users are
                        responsible for the safe use of the test equipment and disposal of any waste fluids in
                        accordance with local laws and regulations. To the fullest extent permitted by law, Chevron: (a)
                        makes no warranties (express or implied) in respect of merchantability or fitness for use and no
                        guarantees or representations are given or implied in the quality and/or performance and/or the
                        accuracy of the screening laboratory, testing procedures or results; (b) will not be responsible
                        or liable for any damage to property of any kind resulting (wholly or partially, directly or
                        indirectly) from use of the screening laboratory or the quality, safety or fitness for use or
                        suitability of the results and/or information; and (c) shall not be liable for any direct,
                        indirect, punitive, incidental, special, or consequential damages, whatsoever arising out of or
                        connected with the use or misuse of the screening laboratory and/or the results and information.
                    </Text>
                    <Text style={{ fontSize: "5px", color: "#333" }}>
                        <Text style={{ fontWeight: "500", fontStyle: "italic" }}>Privacy Statement</Text> - By
                        participating in and using the screening laboratory you consent to Chevron collecting and
                        storing the personal data you provide during registration and use of the screening laboratory.
                        Your personal data is only visible to certain Chevron employees and to your nominated access
                        persons. We will always treat your personal details with the utmost respect and never share them
                        with other organizations outside Chevron. Your personal data will be processed only for the
                        purpose of the screening laboratory and testing records, such records will be used by Chevron
                        technical engineers for the purpose of validation of the tests and/or training. Please be aware
                        that if you provide us with personal data, including sensitive personal data, this will be
                        handled in accordance with our privacy policy, information on which can be found at:{" "}
                        <Link src="http://www.chevron.com/privacystatement/" style={{ color: "#333" }}>
                            http://www.chevron.com/privacystatement/
                        </Link>
                    </Text>
                </View>
            </View>
        </View>
    );
};

export default FooterPDF;
